module.exports = __webpack_public_path__ + "img/tower_radiant.2c0fece8.png";